
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class Invoice extends Vue {
  public formTitle = ' فاکتور فروش';
  public formDeleteTitle = 'آیا مطمئن هستید که می خواهید صورتحساب را ابطال نمایید؟';
  public dialogDelete = false;
  public editedIndex = -1;
  public token = '';
  public redirect = '';
  public desserts = [];
  public headers = [
    { text: 'شماره فاکتور', value: 'id' },
    { text: 'تاریخ', value: 'invoiceDate' },
    { text: 'جمع کل', value: 'netPrice' },
    { text: 'ارزش افزوده', value: 'vat' },
    { text: 'تخفیف', value: 'discount' },
    { text: 'مبلغ فاکتور', value: 'invoicePrice' },
    { text: 'وضعیت', value: 'invoiceStatus' },
    { text: '', value: 'action', sortable: false }
  ];
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'فاکتورهای فروش',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getInvoices().then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async Detail(id: string) {
    this.$router.push({ name: 'InvoiceDetail', params: { id: id } });
  }

  deleteItem(id: number) {
    this.editedIndex = id;
    this.dialogDelete = true;
  }

  async deleteItemConfirm(id: number) {
    this.$showLoading();
    await Api.cancelInvoice(id).then((response: any) => {
      this.$showNotification('success', 'فاکتور با موفقیت ابطال گردید.');
      this.close();
      this.$hideLoading();
    });
  }

  async close() {
    this.dialogDelete = false;
    this.$nextTick(() => {
      this.editedIndex = -1;
    });
    await this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(invoiceStatus: string) {
    if (invoiceStatus === 'پرداخت شده') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
